import React, { useState } from 'react';

import { UiButton } from '../../ui/ui-button';
import { UiDialog } from '../../ui/ui-dialog';
import { UiSelect } from '../../ui/ui-select';

import { ManuallyAddApplicantButton } from '../../job/widgets/manually-add-applicant-button';
import { formatLocation } from '../../util/formatters';
import { sortAlphabetically, SORT_ORDER } from '../../util/sort-functions';

export const AddApplicantDialog = ({
  onClose,
  jobs,
  isSmallScreen,
}: {
  onClose: () => void;
  jobs: Job[];
  isSmallScreen: boolean;
}) => {
  const [jobId, setJobId] = useState<string>('');
  const [orgId, setOrgId] = useState<number | null>(null);

  let jobOptions: Array<SelectOption<string>> = [];
  const jobOrgIds: { [jobId: string]: number } = {};

  jobs.forEach((job) => {
    const stringJobId = job.job_id.toString();
    jobOptions.push({
      label: `${job.org.name} - ${formatLocation(job)} - ${job.title}`,
      value: stringJobId,
    });
    jobOrgIds[stringJobId] = job.orgId;
  });

  jobOptions = jobOptions.sort(sortAlphabetically((o) => o.label, SORT_ORDER.ASC));

  const handleSelectJob = (selectedJobId: string) => {
    setJobId(selectedJobId);
    setOrgId(jobOrgIds[selectedJobId]);
  };

  return (
    <UiDialog onClose={onClose} title="Add Applicant" size="sm">
      <UiDialog.Content>
        <div className={`u-flex-center ${isSmallScreen ? 'u-flexDirection-column' : ''}`}>
          <div className="typo-title">Please select a job to add an applicant to</div>
          <UiSelect
            label="Job"
            className="u-margin-left u-width-200px"
            value={jobId}
            onChange={handleSelectJob}
            options={jobOptions}
          />
        </div>
      </UiDialog.Content>
      <UiDialog.Actions>
        <div className="u-spread u-width-100">
          <UiButton onClick={onClose} variant="secondary" size="sm">
            Cancel
          </UiButton>
          {orgId && (
            <ManuallyAddApplicantButton
              onAddApplicant={onClose}
              orgId={orgId}
              jobId={parseInt(jobId, 10)}
              disabled={!(jobId && orgId)}
              variant="primary"
            />
          )}
        </div>
      </UiDialog.Actions>
    </UiDialog>
  );
};
